export default __webpack_public_path__ + "static/media/notice.d1b8b5b8.svg";